import { config } from "config";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { KeyMap } from "utils/interface";

import { IAnalyticsIdentity } from "./analytics";

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    Beamer?: unknown & {
      toggle: () => void;
    };
    // eslint-disable-next-line camelcase
    beamer_config: KeyMap<string>;
  }
}

export function installBeamer(identity: IAnalyticsIdentity): void {
  if (window.Beamer || window.beamer_config) return;
  Object.defineProperty(window, "beamer_config", {
    value: {
      product_id: config.beamerProductKey,
      display: "popup",
      selector: ".news",
      alert: true,
      button: false,
      first_visit_unread: 0,
      bounce: false,
      ...identity,
    },
  });
  const script = document.createElement("script");
  const style = document.createElement("style");
  style.textContent = `
    .beamer_beamerSelector .beamer_icon.active {
      pointer-events: none;
      background-color: var(${DesignToken.SurfaceAccentEmphasisHighNegative}, #ca0005) !important;
      position: absolute;
      width: 16px;
      height: 16px;
      top: var(${SpacingToken.Spacing05}, 2px);
      right: var(${SpacingToken.Spacing2}, 8px);
}
  `;
  script.src = "https://app.getbeamer.com/js/beamer-embed.js";
  script.defer = true;
  document.head.appendChild(style);
  document.head.appendChild(script);
}
